import { render, staticRenderFns } from "./warehouseOrderInfoByChannel.vue?vue&type=template&id=62fa445e&scoped=true&"
import script from "./warehouseOrderInfoByChannel.vue?vue&type=script&lang=js&"
export * from "./warehouseOrderInfoByChannel.vue?vue&type=script&lang=js&"
import style0 from "./warehouseOrderInfoByChannel.vue?vue&type=style&index=0&id=62fa445e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fa445e",
  null
  
)

export default component.exports